import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    position: "relative",
    display: "inline-flex",
  },
  carouselImage: {
    maxWidth: 125,
    maxHeight: 125,
    objectFit: "cover",
    borderRadius: 8,
    border: "2px solid transparent",
    cursor: "pointer",
    "&:hover": {
      filter: "brightness(0.9)",
    },
    [theme.breakpoints.down("xl")]: {
      width: 75,
      height: 75,
    },
  },
  selectedCarouselImage: {
    border: `2px solid ${theme.palette.secondary.main}`,
  },
}));
